import {
  createObects,
  getObects,
  updateObects,
  deleteObects,
  createWarehouse,
  getWarehouse,
  updateWarehouse,
  getWarehouseId,
  updateWarehouseChecked,
  deletePinnedUser,
  getWarehousePinModal,
} from "@/api/reference";

export default {
  // obects
  CREATE_OBECTS(_, data) {
    return createObects(data);
  },
  FETCH_OBECTS({ commit }, params) {
    return getObects(params).then((res) => {
      commit("SET_OBECTS", res.data);
    });
  },
  UPDATE_OBECTS(_, data) {
    return updateObects(data);
  },

  DELETE_OBECTS(_, id) {
    return deleteObects(id);
  },

  // Warehouse
  CREATE_WAREHOUSE(_, data) {
    return createWarehouse(data);
  },

  FETCH_WAREHOUSE({ commit }, params) {
    return getWarehouse(params).then((res) => {
      commit("SET_WAREHOUSE", res.data);
    });
  },

  FETCH_WAREHOUSE_SCROLL({ commit }, params) {
    return getWarehouse(params).then((res) => {
      commit("SET_WAREHOUSE_SCROLL", res.data);
    });
  },

  FETCH_WAREHOUSE_TABLE({ commit }, params) {
    return getWarehouse(params).then((res) => {
      commit("SET_WAREHOUSE_TABLE", res.data);
    });
  },

  FETCH_WAREHOUSE_LEFT_TABLE({ commit }, params) {
    return getWarehouseId(params).then((res) => {
      commit("SET_WAREHOUSE_ID", res.data);
    });
  },

  FETCH_WAREHOUSE_ID({ commit }, params) {
    return getWarehouseId(params).then((res) => {
      commit("SET_MODALE_WAREHOUSE", res.data);
    });
  },

  UPDATE_CHECKBOX(_, data) {
    return updateWarehouseChecked(data);
  },

  UPDATE_WAREHOUSE(_, data) {
    return updateWarehouse(data);
  },
  DELETE_USERS_PINNED(_, id) {
    return deletePinnedUser(id);
  },
  FETCH_WARE_PINMODAL({ commit }, params) {
    return getWarehousePinModal(params).then((res) => {
      commit("SET_WAREHOUSE_PINMODAL", res.data);
    });
  },
};
